const getFileNameFromHeaders = (headers) => {
  const contentDisposition = headers?.['content-disposition'];
  const fromContentDisposition = contentDisposition?.split('filename=')[1]?.replace(/"/g, '');

  return fromContentDisposition ?? headers?.['x-media-file-name'];
};

export default getFileNameFromHeaders;
